import { FormValues } from "./types";

export const names: Record<keyof FormValues, string> = {
  amount: "amount",
};
